import type { GAEventName } from './ga.types';

// In a utilities file
export const sendGAEvent = (eventName: GAEventName, parameters = {}) => {
  // @ts-expect-error window.dataLayer is loaded by Google Tag Manager
  window.dataLayer = window.dataLayer || [];
  // @ts-expect-error window.dataLayer is loaded by Google Tag Manager
  window.dataLayer.push({
    event: eventName,
    ...parameters,
  });
};
